/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyDetailsBaseResponse as ModelsCustomerNzbnCompanyDetailsBaseResponse } from '../../models/Models/Customer/nzbn-company-details-base-response';

export interface V3PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Params {
  nzbn: string;
  applicationId: string;
}

export function v3PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json(http: HttpClient, rootUrl: string, params: V3PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json.PATH, 'get');
  if (params) {
    rb.path('nzbn', params.nzbn, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyDetailsBaseResponse>;
    })
  );
}

v3PublicApplicationApplicationIdGetCompanyAutocompleteNzbnGet$Json.PATH = '/v3/public/application/{applicationId}/getCompanyAutocomplete/{nzbn}';
